module.exports = __webpack_public_path__ + "img/gray-01-mini.7356b9fd.png";